import React, { useState, useEffect } from 'react'

export const Spinner = ({ 
  size = "md", 
  color = "teal",
  className = "",
  withText = false,
  text = "Loading...",
  timeout = 2000,
  onTimeout
}) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (timeout) {
      const timer = setTimeout(() => {
        setIsLoading(false)
        onTimeout?.()
      }, timeout)

      return () => clearTimeout(timer)
    }
  }, [timeout, onTimeout])

  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-8 w-8",
    xl: "h-12 w-12"
  }

  const colorClasses = {
    teal: "text-teal-500",
    white: "text-white",
    red: "text-red-500",
    gray: "text-gray-500"
  }

  if (!isLoading) return null

  return (
    <div className={`flex items-center ${className}`}>
      <svg 
        className={`animate-spin ${sizeClasses[size]} ${colorClasses[color]}`} 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24"
      >
        <circle 
          className="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="4"
        />
        <path 
          className="opacity-75" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {withText && (
        <span className={`ml-2 text-sm ${colorClasses[color]}`}>
          {text}
        </span>
      )}
    </div>
  )
} 